module.exports = __webpack_public_path__ + "img/ic_company-logo_14.b4b64f0c.svg";